import { API } from 'aws-amplify';

import { authHeader } from 'utils/auth';

export async function checkout(reportId: string): Promise<any> {
  const apiName = 'stripeAPI';
  const path = `/report/${reportId}/stripe/checkout`;
  const headers = await authHeader();

  try {
    return await API.post(apiName, path, {
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}
